export default "__VITE_ASSET__CVlujI3o__"